import { Container } from "@/components/pieces/bootstrap";

export function Catalyst() {
  return (
    <div className="bg-linear-to-r from-blue-900 to-blue-800 py-12 md:py-24">
      <Container className="!max-w-marketing-content">
        <div className="flex flex-col items-center">
          <div className="mt-3 max-w-3xl text-2xl leading-relaxed text-white">
            <p className="mb-4">
              Humans are hardwired to pursue excellence. Given the right
              conditions—challenge, feedback, and opportunity—people naturally
              seek to master their craft. Work isn't merely a place to earn a
              living; it's the ideal environment for this pursuit.
            </p>

            <p>
              Exec exists to support our clients with the infrastructure to
              scale excellence. Our talent development platform combines the
              precision and tirelessness of AI with the irreplaceable guidance
              of expert coaches to cultivate the dormant potential in every
              employee.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}
